module.exports = __webpack_public_path__ + "static/media/wxlogin_logo.05cc53e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wx/wxlogin_logo.png
// module id = 321
// module chunks = 150